<template>
    <div class="map-page-login map-center-layout" :class="{'map-loading': loading }">
        <div class="map-page-content">
            <h1 class="map-lineunder">Reset Password</h1>
            <loader />
            <form @submit.prevent="reset">
                <base-input
                    type="email"
                    placeholder="Email"
                    v-model="model.email"
                    :error="get_errors('email')"
                    >
                </base-input>
                <Button type="submit" class="map-color-primary">SEND EMAIL</Button>
                <router-link to="/user/login" class="icph-label-button">Sign In</router-link>
                <span>&nbsp;|&nbsp;</span>
                <a href="mailto:support_movementaccelerator@ippf.org" target="_blank">Contact Us</a>
            </form>
        </div>
    </div>
</template>

<script>
    import useVuelidate from '@vuelidate/core';
    import { required, email } from '@vuelidate/validators';
    import { AuthService } from '@/services';

    import BaseInput from '@/components/Inputs/BaseInput';
    import Button from '@/components/Buttons/Button';
    import Loader from '@/components/Loader';

    export default
    {
        name: 'Login',
        components:
        {
            BaseInput,
            Button,
            Loader,
        },
        setup()
        {
            return { v$: useVuelidate() };
        },
        data()
        {
            return {
                submitted: false,
                loading: false,
                mail_sent: false,
                response: '',
                error: '',
                model:
                {
                    email: '',
                },
            };
        },
        validations()
        {
            return {
                model:
                {
                    email: { required, email },
                },
            };
        },
        methods:
        {
            async reset()
            {
                if (this.mail_sent)
                {
                    this.$router.push({ name: 'Login' });
                }

                const is_valid = await this.v$.$validate();

                if (!is_valid)
                {
                    return ;
                }

                this.loading = true;

                const response = await AuthService.request_reset_password(
                {
                    email: this.model.email,
                });

                this.mail_sent = response.data.success;
                this.response = response.data.status;

                this.loading = false;
            },

            get_errors(field, message)
            {
                const $err = this.v$.model[field];

                if ($err.$error)
                {
                    return message || $err.$errors.map((err) => err.$message).join(' - ');
                }

                return false;
            }
        },
    };
</script>
